import {Decimal} from "decimal.js";
import {Patient} from "./patient";
import {Doctor} from "./doctor";
import {DateTime} from "ionic-angular";

export class Exam {
  Id: string;
  Patient: Patient;
  PatientId: string;
  Doctor: Doctor;
  DoctorId: string;
  CreatedStamp: Date;
  CoreScore: number;
  CoreScoreVersion: string;
  HrvScanId: string;
  HrvScore: number;
  HrvScoreVersion: string;
  ThermalScanId: string;
  ThermalScore: number;
  ThermalScoreVersion: string;
  EmgScanId: string;
  EmgScore: number;
  EmgScoreVersion: string;
  AlgoScanId: string;
  AlgoScore: number;
  AlgoScoreVersion: string;
  RomScanId: string;
  RomScore: number;
  RomScoreVersion: string;

  ReportType: ExamType;
  get CreatedDate(): string {
    let scanDate = new Date(this.CreatedStamp.toString());
    return scanDate.toLocaleString();
  }
}

export enum ExamType
{
  Initial,
  Progress,
  Comparative,
  Continuation,
  DualHrv,
  DualTherm,
  Single,
  ROM,
  Algo,
  Invalid
}

export function GetExamName(examType: ExamType): string {
  switch (ExamType[examType.toString()]) {
    case ExamType.Initial:
      return "CORESCORE Initial Report";
    case ExamType.Progress:
      return "CORESCORE Progress Report";
    case ExamType.Comparative:
      return "CORESCORE Comparative Report";
    case ExamType.Continuation:
      return "CORESCORE Continuation Report";
    case ExamType.DualHrv:
    case ExamType.DualTherm:
      return "Dual Report";
    case ExamType.Single:
      return "Single Report";
    case ExamType.Invalid:
      return "Invalid Report";
  }
}

export function IsCorescore(examType: ExamType): boolean {
  if (examType == ExamType.Comparative || examType == ExamType.Initial || examType == ExamType.Progress ||examType ==  ExamType.Continuation) {
    return true;
  }
  if(examType.toString() == 'Comparative' || examType.toString() == 'Initial' || examType.toString() == 'Progress' || examType.toString() == 'Continuation'){
    return true;
  }
  else {
  return false;
  }
}



// WEBPACK FOOTER //
// ./src/model/exam.ts